import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./css/multi-select-dropdown.css"; // Reuse existing CSS

const DatePickerComponent = ({
  label,
  required,
  selectedDate,
  setSelectedDate,
  isError,
  errorMessage,
}) => {
  const [isActive, setIsActive] = useState(false);
  const datePickerRef = useRef(null);

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedDate(null);
  };

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div
      className={`pre-booking-multi-select-input ${isError && "error-border"}`}
      onClick={onClick}
    >
      {label && (
        <label
          className={`pre-booking-multi-select-label ${
            isError ? "error-label" : ""
          }`}
        >
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div
        className={`pre-booking-selected-container ${
          isActive ? "dropdown-active" : ""
        }`}
      >
        {value ? (
          <span className="pre-booking-selected-item-single">{value}</span>
        ) : (
          <span className="pre-booking-placeholder-text">MM/DD/YYYY...</span>
        )}
      </div>

      {value && (
        <button
          className={`pre-booking-clear-btn ${
            isActive ? "dropdown-cancel-active" : ""
          }`}
          onClick={handleClear}
        >
          Clear
        </button>
      )}

      <button className="pre-booking-toggle-btn">▼</button>
    </div>
  ));

  return (
    <div className="pre-booking-multi-select-wrapper" ref={datePickerRef}>
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        customInput={<CustomInput />}
        dateFormat="MM/dd/yyyy"
        placeholderText=""
        onCalendarOpen={() => setIsActive(true)}
        onCalendarClose={() => {
          if (!selectedDate) setIsActive(false);
        }}
        style={{ width: "100%" }}
      />
      {isError && <p className="pre-booking-error-message">{errorMessage}</p>}
    </div>
  );
};

export default DatePickerComponent;
